export default __webpack_public_path__ + "static/media/poison.fe41a0ec.svg";